import { Trans } from '~/common/context';
import { BackLink, Card, Col, Icon, Row, Title } from '@wyz/ui';
import { IJob } from '~/common/types';
import { ConnectQueryKeys } from '~/connect/api';
import { ImportForm, ImportTable } from '~/connect/components';
import * as React from 'react';

type Props = {
  title: React.ReactNode;
  type: IJob['type'];
};
export default function CustomersImportView({ title, type }: Props) {
  return (
    <>
      <BackLink to='..'>
        <Icon icon='arrow-left-s-line' width={20} height={20} />
        <Trans i18nKey='app.entity.form.back_button' />
      </BackLink>
      <Title heading='page-title' weight='bold'>
        {title}
      </Title>
      <Card className='mb-section'>
        <Card.Body>
          <ImportForm type={type} />
        </Card.Body>
      </Card>
      <Row>
        <Col>
          <ImportTable
            queryKey={ConnectQueryKeys.jobs.list(type)}
            type={type}
          />
        </Col>
      </Row>
    </>
  );
}
